<template>
<div class="chapter">
<div class="inner_page">
<p class="ep" id="epi"><span class="epub-i">We poets in our youth begin in gladness;</span></p>
<p class="ep-bot"><span class="epub-i">But thereof comes in the end despondency and madness.</span></p>
<p class="epc">—W<span class="epub-sc">ORDSWORTH</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?164f362c